export default __webpack_public_path__ + "static/media/folder-star.8ab8249a.svg";